import { NodeId } from "@craftjs/core";
import { EventHandlerConnectors } from "@craftjs/utils";
import React from "react";

import { LayerHandlers } from "../events/LayerHandlers";

export const LayerContext = React.createContext({});
